<template>
    <div class="ui dropdown item" v-dropdown
        :class="{
            'router-link-active': is_in_this_dropdown
        }"
    >
        <i class="dropdown large icon"></i>
        <i class="icons">
            <i :class="service_config_menu.icon+' icon'"></i>
            <span> {{ $t('ui.links.menu.'+service_config_menu.name) }} </span>
        </i>
        <div class="menu">
            <SidebarDropdownItem
                v-for="item in service_config_menu.items"
                class="item"
                :item="item"
                :key="item.name">
            </SidebarDropdownItem>
        </div>
    </div>
</template>

<script>
import SidebarDropdownItem from '@partials/provider/sidebar_dropdown_item.vue'

export default {
    props: {
        service_config_menu: {
            type: Object,
            default() {
                return {}
            },
        },
    },
    data() {
        return {
            is_in_this_dropdown: false,
            is_can_use: this.check_can_use_current_menu(),
        }
    },
    computed: {
    },
    watch: {
        '$route': {
            immediate: true,
            handler(to, from) {
                // 例外狀況
                if (to.name == 'driver_commission_policies' && this.service_config_menu.name == "commission_reports") {
                    return false
                }

                // 三元運算
                // 當前route名稱包含 item名稱結尾去除s字串時 is_in_this_dropdown 設為true
                this.is_in_this_dropdown = (
                    _.findLast(this.service_config_menu.items, (item) => {
                        return to.name.indexOf(item.name.replace(/s$/g, '')) != '-1'
                    })
                ) ? true : false
            }
        },
    },
    mounted() {
    },
    methods: {
        check_can_use_current_menu() {
            var reslut = [];

            try {
                _.forEach(this.service_config_menu.items, (item) => {
                    reslut.push(
                        _.findLast(this.$store.state.provider.theme_menu, (menu_name) => {
                            return item.name == menu_name
                        })
                    )
                })
                _.remove(reslut, _.isUndefined);
                return (reslut.length) ? true : false
            } catch (e) {
                return false
            }

            return false
        },
    },
    components: {
        SidebarDropdownItem,
    },
}
</script>
